export enum EActiveBlock {
  CONSULTATION = 'CONSULTATION',
  FINANCING_ORDER = 'FINANCING_ORDER',
  SUCCESS_FINANCING_OFFER = 'SUCCESS_FINANCING_OFFER',
  ERROR = 'ERROR',
  COMMUNICATION_METHOD = 'COMMUNICATION_METHOD',
}
